import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WebcamImage, WebcamInitError, WebcamComponent, WebcamUtil } from 'ngx-webcam';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-instruccionesfoto',
  templateUrl: './instruccionesfoto.component.html',
  styleUrls: ['./instruccionesfoto.component.scss']
})
export class InstruccionesfotoComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(WebcamComponent) webcam!: WebcamComponent;

  hide_camera: boolean = true;
  camera_permission_error: boolean = false;
  camera_system_error: boolean = false;
  confirm: boolean = false;
  retryButton: boolean = false;
  isInitializing: boolean = false;

  preview_image: string = '';

  videoOptions: MediaTrackConstraints = {
    width: { ideal: 1280 },
    height: { ideal: 1440 },
    facingMode: 'environment'
  };

  // Variables para control de múltiples cámaras
  allowCameraSwitch: boolean = true;
  multipleWebcamsAvailable: boolean = false;
  activeDeviceId: string = '';
  availableVideoDevices: MediaDeviceInfo[] = [];

  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject< boolean | string > = new Subject< boolean | string >();

  private blank_photo = "data:image/jpeg;base64,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";

  constructor(
    public dialog: MatDialog,
    public utilityService: UtilitiesService,
    private dialogRef: MatDialogRef<InstruccionesfotoComponent>
  ) {}

  ngOnInit(): void {
    this.checkDeviceAvailability();
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.stopMediaTracks();
  }

  private stopMediaTracks(): void {
    if (this.webcam && this.webcam.nativeVideoElement) {
      if (this.webcam.nativeVideoElement.srcObject) {
        this.webcam.nativeVideoElement.srcObject.getTracks().forEach((track: any) => track.stop());
      }
    }
  }

  private checkDeviceAvailability(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.availableVideoDevices = mediaDevices;
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;

        if (mediaDevices.length === 0) {
          this.camera_system_error = true;
          location.reload();
        }
      })
      .catch(error => {
        console.error('Error al detectar cámaras disponibles:', error);
        this.camera_system_error = true;
        location.reload();
      });
  }

  activateCamera(): void {
    this.isInitializing = true;
    this.camera_permission_error = false;
    this.camera_system_error = false;

    navigator.mediaDevices.getUserMedia({
      video: this.videoOptions,
    }).then((response) => {
      console.log('Permisos de cámara concedidos:', response);

      response.getTracks().forEach((track) => {
        track.stop();
      });

      this.proceed();
    }).catch((err) => {
      console.error('Error al solicitar permisos de cámara:', err);
      if (err?.name === 'NotAllowedError' || err?.message === 'Permission denied') {
        this.camera_permission_error = true;
      } else {
        this.camera_system_error = true;
        location.reload();
        this.retryButton = true;
      }
      this.isInitializing = false;
    });
  }

  proceed(): void {
    this.hide_camera = false;
    this.isInitializing = false;
  }

  handleImage(webcamImage: WebcamImage): void {
    console.log('Imagen recibida de la webcam:', webcamImage);

    if (this.blank_photo === webcamImage.imageAsDataUrl) {
      console.warn('Se detectó una imagen en blanco, no se procesará');
      return;
    }

    this.preview_image = webcamImage.imageAsDataUrl;
    this.confirm = true;
  }

  handleInitError(error: WebcamInitError): void {
    console.error('Error al inicializar la cámara:', error);

    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      this.camera_permission_error = true;
    } else {
      this.camera_system_error = true;
      location.reload();
    }

    this.hide_camera = true;
  }

  showNextWebcam(directionOrDeviceId: boolean|string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  selectCamera(deviceId: string): void {
    this.activeDeviceId = deviceId;
    this.showNextWebcam(deviceId);
  }

  cameraWasSwitched(deviceId: string): void {
    console.log('Cámara activa cambiada a: ' + deviceId);
    this.activeDeviceId = deviceId;
  }

  retry(): void {
    this.confirm = false;
    this.preview_image = '';
  }

  firmar(): void {
    console.log('Firmando con la imagen capturada');
    this.dialogRef.close({ photo: this.preview_image });
  }

  takePhoto(): void {
    this.trigger.next();
  }

  volver(): void {
    navigator.mediaDevices.getUserMedia({video: true}).then((stream) => {
      stream.getTracks().forEach((track) => track.stop());
    }).catch((error) => {
      console.error('Error al intentar liberar la cámara:', error);
    });

    this.dialogRef.close();
  }

  get $trigger(): Observable<void> {
    return this.trigger.asObservable();
  }

  get $nextWebcam(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }
}